module.exports = __webpack_public_path__ + "media/images/area/feature/chubu/related/zh-hant/6-724c23a23c843064cc9352c6766dd37f.jpg";